export default "__VITE_ASSET__Dr06yxvH__"